<a class="ppp-summary-card" routerLink="/preferred-partner" *ngIf="summary$ | async as summary; else loadingTpl">
  <div class="ppp-summary-card__header">
    <h3 class="ppp-summary-card__title">Preferred Partner Program</h3>
    <span class="ppp-summary-card__week">Week of {{ summary.weekStart }}</span>
  </div>

  <div class="ppp-summary-card__totals">
    <div class="ppp-summary-card__metric">
      <span class="ppp-summary-card__metric-value">{{ summary.totals.totalBonusCents | centsToDollars }}</span>
      <span class="ppp-summary-card__metric-label">Bonus this week</span>
    </div>
    <div class="ppp-summary-card__metric">
      <span class="ppp-summary-card__metric-value">{{ summary.totals.driversEligibleAtClose }}</span>
      <span class="ppp-summary-card__metric-label">Drivers eligible</span>
    </div>
    <div class="ppp-summary-card__metric">
      <span class="ppp-summary-card__metric-value">{{ summary.totals.shiftsEvaluated }}</span>
      <span class="ppp-summary-card__metric-label">Shifts evaluated</span>
    </div>
  </div>

  <div class="ppp-summary-card__regions">
    <div class="ppp-summary-card__region" *ngFor="let region of summary.byRegion; trackBy: trackByRegion">
      <span class="ppp-summary-card__region-name">{{ region.regionName }}</span>
      <lohi-eligibility-status-chip
        [eligible]="region.carrierEligible"
        [inAllowlist]="region.inAllowlist"
        size="sm"
      ></lohi-eligibility-status-chip>
    </div>
  </div>

  <div class="ppp-summary-card__cta">
    <span>View details</span>
    <mat-icon>chevron_right</mat-icon>
  </div>
</a>

<ng-template #loadingTpl>
  <div class="ppp-summary-card ppp-summary-card--loading">
    <h3 class="ppp-summary-card__title">Preferred Partner Program</h3>
    <p class="ppp-summary-card__loading-text">Loading summary…</p>
  </div>
</ng-template>
